module.exports = __webpack_public_path__ + "static/img/cont45 (1).9f8e9aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45 (1).jpg
// module id = oSt5
// module chunks = 0